import React from 'react';
import { Row, Typography, message } from 'antd';
import UploadBox from './uploadBox';
import RecordBox from './recordBox';

const { Title } = Typography;

const VideoUploadOrRecord = ({
    draggerProps,
    draggerRef,
    token,
    previewVideo,
    userProfile,
    state,
    editFieldCheck,
    checkPermission
}) => {
    const isDisabled = previewVideo || editFieldCheck('standups', 'files', userProfile) === false;
    const borderColor = token.colorPalette.baseColor.tertiary;

    const handleRecordClick = () => {
        if (!isDisabled) {
            if (state?.fileURL?.length > 0) {
                message.info('You have already uploaded video');
            } else {
                checkPermission();
            }
        }
    };

    return (
        <Row justify="space-between" align="middle" style={{ width: '100%', marginBottom: '20px' }}>
            <UploadBox
                draggerProps={draggerProps}
                draggerRef={draggerRef}
                disabled={isDisabled}
                borderColor={borderColor}
            />

            <Title level={4}>OR</Title>

            <RecordBox
                disabled={isDisabled}
                onClick={handleRecordClick}
                borderColor={borderColor}
            />
        </Row>
    );
};

export default VideoUploadOrRecord;
